var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"w-container-filter-image-bkg filter_bkg_image",staticStyle:{"padding-top":"59px","background-color":"rgb(255 255 255 / 50%)","overflow-x":"hidden"}})}
var staticRenderFns = []

export { render, staticRenderFns }